import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';
import SavedFiltersDropdown from '../SavedFiltersDropdown/SavedFiltersDropdown';
import SaveFilterBlock from '../SaveFilterBlock/SaveFilterBlock';
import useSavedFilters from '../../queries/useSavedFilters';
import { getSearchParamsObj } from '../../helpers/searchParamsFns';
import { filtersData } from '../../constants/filtersData';
import deepCompareObjects from '../../../../helpers/deepCompareObjects';
import { isDefaultFilter } from '../../helpers/isDefaultFilter';
import styles from './FilterActions.module.scss';

const defaultBtnText = 'Выбрать сохраненный фильтр';

const Actions = ({ defaultFilter, setDefaultFilter, className }) => {
  const [dropdownBtnText, setDropdownBtnText] = useState(defaultBtnText);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);

  const location = useLocation();

  const { data: savedFilters } = useSavedFilters({ staleTime: Infinity });

  // set dropdown button text and disabled state for save button
  useEffect(() => {
    let text = defaultBtnText;
    let disabled = isDefaultFilter(location.search);

    if (savedFilters?.length) {
      const filtersObj = getSearchParamsObj(location.search, filtersData);

      const selectedFilter = savedFilters.find((item) =>
        deepCompareObjects(item.filter, filtersObj)
      );

      if (selectedFilter) {
        text = selectedFilter.name;
        disabled = true;
      }
    }

    setSaveBtnDisabled(disabled);
    setDropdownBtnText(text);
  }, [savedFilters, location.search]);

  return (
    <div className={cn(styles.root, className)}>
      <SavedFiltersDropdown
        setDefaultFilter={setDefaultFilter}
        defaultFilter={defaultFilter}
        buttonText={dropdownBtnText}
        resetButtonDisabled={dropdownBtnText === defaultBtnText}
      />
      <SaveFilterBlock disabled={saveBtnDisabled} />
    </div>
  );
};

export default Actions;
